import { useState } from "react";
import InputWrapperRefacture from "../../UI/Inputs/InputWrapperRefacture";
import ErrorBoxCS from '../../UI/ErrorBox/ErrorBox';
import "./ProductOfferPromoCode.scss";

// Static promo codes for testing
const VALID_CODES = ["SAVE10", "WELCOME", "TEST123"];

export default function ProductOfferPromoCode({ onApplied, onRemoved }) {
    const [promoCode, setPromoCode] = useState("");
    const [applied, setApplied] = useState(false);
    const [appliedCode, setAppliedCode] = useState("");
    const [error, setError] = useState(false);

    const applyPromoCode = () => {
        setError(false);

        if (!promoCode.trim()) {
            setError("blank");
            return;
        }

        if (VALID_CODES.includes(promoCode.toUpperCase())) {
            setApplied(true);
            setAppliedCode(promoCode);
            if (onApplied) onApplied(promoCode);
        } else {
            setError("invalid");
        }
    };

    const removePromoCode = () => {
        setPromoCode("");
        setApplied(false);
        setAppliedCode("");
        setError(false);
        if (onRemoved) onRemoved();
    };

    const handleOnChange = (value) => {
        setPromoCode(value);
        setError(false);
    };

    if (applied) {
        return (
            <div className="promo-applied-tag">
                <span className="promo-tag-icon">&#9998;</span>
                <span className="promo-tag-code">{appliedCode}</span>
                <button className="promo-tag-remove" onClick={removePromoCode} aria-label="Remove promo code">&times;</button>
            </div>
        );
    }

    return (
        <div>
            <div className="item-wrapper">
                <InputWrapperRefacture
                    inputSize="full-width"
                    inputFieldType="text"
                    btnText="Apply"
                    value={promoCode}
                    id="promoCode"
                    name="promoCode"
                    placeholder="Enter promo code"
                    onClickFunction={applyPromoCode}
                    aria-invalid={!!error}
                    aria-describedby="promocode-alerts"
                    invalidClass={error ? "Invalid-input" : ""}
                    onChange={(e) => handleOnChange(e.target.value)}
                />
                {error === "blank" && <span role="alert" id="promocode-alerts"><ErrorBoxCS>Please enter a promo code</ErrorBoxCS></span>}
                {error === "invalid" && <span role="alert" id="promocode-alerts"><ErrorBoxCS>Promo code is invalid</ErrorBoxCS></span>}
            </div>
        </div>
    );
}
